var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",class:['text-style', _vm.variation, `color-${_vm.color}`, _vm.size, _vm.custom]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }